export default {
	title: 'Biblioteca de Rodamientos',
	selectAll: 'Seleccionar Todo',
	selectedCount: '{count} elementos seleccionados',
	batchDelete: 'Eliminar en Lote',
	batchDeleteWithCount: 'Eliminar en Lote ({count})',
	noData: {
		title: 'No Hay Datos de Rodamientos',
		description: 'No se encontraron datos de rodamientos'
	},
	actions: {
		add: 'Agregar',
		edit: 'Editar',
		delete: 'Eliminar',
		batchDelete: 'Eliminar en Lote'
	},
	messages: {
		deleteConfirm: '¿Está seguro de que desea eliminar los {count} registros seleccionados?',
		deleteSuccess: 'Eliminación exitosa',
		selectDeleteWarning: 'Por favor seleccione registros para eliminar',
		operateSuccess: 'Operación exitosa',
		requiredFieldCannotBeEmpty: 'El campo obligatorio no puede estar vacío'
	},
	form: {
		designation: 'Designación del Rodamiento',
		brand: 'Marca del Rodamiento',
		bpfo: 'BPFO',
		bpfi: 'BPFI',
		bsf: 'BSF',
		ftf: 'FTF',
		placeholder: {
			designation: 'Por favor ingrese la designación del rodamiento',
			brand: 'Por favor ingrese la marca del rodamiento',
			bpfo: 'Por favor ingrese BPFO',
			bpfi: 'Por favor ingrese BPFI',
			bsf: 'Por favor ingrese BSF',
			ftf: 'Por favor ingrese FTF'
		}
	},
	table: {
		designation: 'Designación del Rodamiento',
		brand: 'Marca del Rodamiento',
		bpfo: 'BPFO',
		bpfi: 'BPFI',
		bsf: 'BSF',
		ftf: 'FTF'
	},
	dialog: {
		add: 'Agregar',
		edit: 'Editar',
		cancel: 'Cancelar',
		confirm: 'Confirmar'
	}
}
